// extracted by mini-css-extract-plugin
export var root = "AnimatedLine-module--root--3_BnR";
export var horizontal = "AnimatedLine-module--horizontal--2EHqe";
export var vertical = "AnimatedLine-module--vertical--1Izvo";
export var top = "AnimatedLine-module--top---I96A";
export var bottom = "AnimatedLine-module--bottom--2o7Cb";
export var left = "AnimatedLine-module--left--3MLIe";
export var right = "AnimatedLine-module--right--rTZsZ";
export var light = "AnimatedLine-module--light--2815-";
export var dark = "AnimatedLine-module--dark--3TBG4";